export enum TypeErrors {
  MAX_RETRIES_EXCEEDED = 'MAX_RETRIES_EXCEEDED'
}